import { render, staticRenderFns } from "./QnaDetail.vue?vue&type=template&id=08cecc86&scoped=true"
import script from "./QnaDetail.vue?vue&type=script&lang=js"
export * from "./QnaDetail.vue?vue&type=script&lang=js"
import style0 from "./QnaDetail.vue?vue&type=style&index=0&id=08cecc86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cecc86",
  null
  
)

export default component.exports